export default "__VITE_ASSET__R_R7T1Ms__"